import lottie from 'lottie-web'

export default class Lottie {
    constructor(el) {
        this.el = el

        const path = this.el.getAttribute('data-src')

        if (!path || path === '') return

        this.lottie = lottie.loadAnimation({
            container: this.el,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path
        })

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.lottie.play()
                } else {
                    this.lottie.stop()
                }
            })
        }, { threshold: 0.05 })

        observer.observe(this.el)
    }
}